"use client"

import { CheckCircle2 } from "lucide-react"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"
import { StatusTag } from "@shared/ui/landing/status-tag"

import { useTranslations } from "@/lib/i18n/client"

const REPORT_HIGHLIGHTS = [
  "exposureGraph",
  "entityResolution",
  "sanctionsMatch",
  "velocityProfile",
  "jurisdictionMap",
  "auditTrail",
] as const

export function ReportShowcaseSection() {
  const t = useTranslations("report")

  return (
    <SectionContainer id="report" className="bts-grid-bg rounded-3xl border border-white/5">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div className="space-y-6">
          <div className="space-y-3">
            <StatusTag variant="info">{t("badge")}</StatusTag>
            <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t("title")}</h2>
            <p className="text-muted-foreground">{t("subtitle")}</p>
          </div>
          <ul className="space-y-3">
            {REPORT_HIGHLIGHTS.map((key) => (
              <li key={key} className="flex items-start gap-2 text-sm">
                <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>{t(`highlights.${key}`)}</span>
              </li>
            ))}
          </ul>
        </div>
        <GlassCard className="space-y-4 font-mono text-sm">
          <div className="flex items-center justify-between border-b border-white/10 pb-3">
            <span className="text-muted-foreground">{t("reportId")}</span>
            <span>BTS-2026-08421</span>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-xs text-muted-foreground">{t("riskScore")}</p>
              <p className="text-3xl font-bold text-amber-400">72</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground">{t("classification")}</p>
              <StatusTag variant="warning">{t("classificationValue")}</StatusTag>
            </div>
          </div>
          <div className="space-y-2 rounded-xl border border-white/10 bg-black/30 p-4">
            <p className="text-xs uppercase tracking-wider text-muted-foreground">
              {t("summary")}
            </p>
            <p className="text-xs leading-relaxed text-muted-foreground">{t("summaryBody")}</p>
          </div>
          <div className="grid grid-cols-3 gap-2 text-center text-xs">
            <div className="rounded-lg bg-white/5 p-2">
              <p className="text-muted-foreground">{t("exposure")}</p>
              <p className="font-semibold">$2.4M</p>
            </div>
            <div className="rounded-lg bg-white/5 p-2">
              <p className="text-muted-foreground">{t("hops")}</p>
              <p className="font-semibold">14</p>
            </div>
            <div className="rounded-lg bg-white/5 p-2">
              <p className="text-muted-foreground">{t("entities")}</p>
              <p className="font-semibold">8</p>
            </div>
          </div>
        </GlassCard>
      </div>
    </SectionContainer>
  )
}
